import { defineStore } from 'pinia'
import type { FrontendQuoteInterface } from '~/types/quoteTypes'
import { useLanguageStore } from '~/store/language'
import { fetchRetryParameters, requestHostHeaders } from '~/composables/constants/api'
import type { RequestHostHeadersType } from '~/composables/constants/api'

interface ContentInterface {
  current_page: number
  selected_filter: string
  total_items: number
  available_items: FrontendQuoteInterface[]
}

export const useOrdersContentStore = defineStore('ordersContentStore', {
  state: (): ContentInterface => ({
    current_page: 1,
    selected_filter: 'all_orders',
    total_items: 0,
    available_items: [],
  }),
  getters: {
    currentPage(state) {
      return state.current_page
    },
    selectedFilter(state) {
      return state.selected_filter
    },
    totalItems(state) {
      return state.total_items
    },
    availableItems(state): FrontendQuoteInterface[] {
      return state.available_items
    },
  },
  actions: {
    setSelectedFilter(value: string) {
      this.selected_filter = value
      this.current_page = 1
    },
    setCurrentPage(value: number) {
      this.current_page = value
    },
    setTotalItems(value: number) {
      this.total_items = value
    },
    setAvailableItems(value: FrontendQuoteInterface[]) {
      this.available_items = value
    },
    async updateAvailableItems() {
      try {
        const language_id = useLanguageStore().getLanguageId
        const { isTarpininke } = useTheme()

        const response = await $fetch('/api/my-orders/get-my-orders', {
          method: 'POST',
          body: {
            language_id,
            page: this.current_page,
            type_for_filter: isTarpininke ? null : this.selected_filter,
          },
          ...fetchRetryParameters,
          headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
        })

        this.setAvailableItems(response.items)
        this.setTotalItems(response.total)
      } catch (e) {
        this.setAvailableItems([])
        this.setCurrentPage(1)
        this.setTotalItems(0)
      }
    },
  },
})
